import {
  el,
  state,
} from "./core.js"
import { encodeOutput as encodeBaseOutput } from "./encoder-core.js"
import {
  resumePreviewAfterConversion,
  suspendPreviewForConversion,
} from "./preview.js"

let starting = false

export async function encodeOutput() {
  if (starting || state.encoding || !state.file || !state.videoTrack) return
  starting = true
  el.convertButton.disabled = true
  el.statusText.textContent = "Stopping preview before conversion…"

  try {
    await suspendPreviewForConversion()
    await encodeBaseOutput()
  } finally {
    const shouldRebuildPreview = !state.resultUrl && Boolean(state.file && state.videoTrack)
    resumePreviewAfterConversion({ rebuild: shouldRebuildPreview, delay: 200 })
    starting = false
    if (!state.encoding) el.convertButton.disabled = !state.file || !state.videoTrack
  }
}
